import store from "../store"
export const FIRST_CATEGORY = [
    {
        typeId:'1',
        typeValue:'新三板'
    },
    {
        typeId:'2',
        typeValue:'VC/PE'
    },
    {
        typeId:'3',
        typeValue:'定增'
    },
    {
        typeId:'4',
        typeValue:'私募债'
    },
    {
        typeId:'5',
        typeValue:'ABS'
    },
    {
        typeId:'6',
        typeValue:'困境投资'
    },
    {
        typeId:'7',
        typeValue:'并购'
    },
    {
        typeId:'8',
        typeValue:'PIPE'
    }
]
export const PROFESSIONAL_TYPE = ['114','124','125','126','121','122']
export const REQUEST_LIST  = ["cms/cmsGroupAccount/add",
    "cms/cmsGroupAccount/individualAccount",
    "cms/cmsGroupAccount/getLocationList",
    "cms/cmsGroupAccount/typeOfCertificates",
    "cms/cmsGroupAccount/modifyOccupation",
    "cms/InvestorCreitApply/investorIdentificationA",
    "cms/InvestorCreitApply/investorIdentificationApplicationOrg",
    "cms/InvestorCreitApply/status",
    "cms/countryLoadLocationList",
    "cms/loadLocationList",
    "cms/loadCityList",
    "cms/loadAreaList",
    "cms/cmsBank/bindBankCard",
    "cms/cmsBank/BankAccountManagements",
    "cms/cmsBank/BankAccountWithholding",
    "cms/adequacyManagement/getQuestionList",
    "cms/adequacyManagement/evaluating",
    "oss/fileUpload",
    "oss/multiFileUpload",
    "pms/product/pub/recommender",
    "pms/product/pub/findFundListByType",
    "pms/product/pub/fixedInvestmentZone",
    "cms/cmsGroupAccount/specificNaturalPerson",
    "home/homepageDisplayData",
    "cms/adequacyManagement/getResults",
    "cms/cmsGroupAccount/getTheSubjectById",
    "cms/cmsGroupAccount/checkAlreadyFa",
    "cms/provinceCityDistrictList",
    "personalCenter/detectUpdates",
    "cms/OrgOpen/enumerateOrg",
    "tms/fixedInput/fixedInputPlanHandle",
    "tms/fixedInput/generateFixedInputOrder",
    "cms/OrgOpen/orgAdd",
    "cms/OrgOpen/modifyGroupLegalPerson",
    "cms/OrgOpen/modifyAuthorizedManager",
    "cms/OrgOpen/insertBeneficiary",
    "cms/OrgOpen/insertActualController",
    "cms/InvestorCreitApply/updateByCompanyAppAdmit",
    "redeem/tms/private/redeemMeiShiParam",
    "tms/pub/booking/getMeiShiParam",
    "tms/booking/getMeiShiParam",
    "personalCenter/settingLoginPassword",
    "personalCenter/identityCheckOfRetrievePassword",
    "personalCenter/verificationCodeCheckOfRetrievePassword",
    "personalCenter/findBranchBankList",
    "orgPersonalCenter/findBranchBankList",
    "check/smsVerificationCode",
    "tms/booking/getMeiShiParam",
    "cms/OrgOpen/selectCmsGroupOrg",
    "cms/OrgOpen/selectCmsGroupOrg",
    "cms/OrgOpen/insertInstitutionalTaxation",
    "pms/product/pub/productRiskLevel",
    "cms/cmsGroupAccount/checkAlreadyImage",
    "cms/cmsGroupAccount/checkImageUnanimous",
    "cms/cmsGroupAccount/addIdImage",
    "check/smsVerificationCode",
    "login/automatic",
    "pms/product/pub/riskValidate",
    "pms/product/pub/productBaseInfo",
    "pms/product/pub/productFundNAVList",
    "pms/product/pub/assetAllocation",
    "pms/product/pub/holdingsSecurities",
    "pms/product/pub/publicFundOverview",
    "pms/product/pub/fundAnnouncements",
    "pms/product/pub/announcement/detail",
    "pms/product/pub/industrialDistribution",
    "pms/product/pub/fundDividendRecord",
    "pms/product/pub/listOfFundManagers",
    "pms/product/pub/fundPerformanceTrend",
    "pms/product/pub/unitEquityTrend",
    "pms/product/pub/cumulativeNetWorthTrend",
    "pms/product/pub/netWorthTrendEstimation",
    "pms/product/pub/open/estimation",
    "pms/product/pub/isOpen/estimation",
    "pms/product/pub/rule",
    "pms/product/pub/newFundDetails",
    "pms/product/pub/pubFundRatingSystem",
    "pms/product/private/investmentAgencyDetails",
    "pms/pub/assetsSurvival/annualizedTrend",//七日年化走势图
    "pms/pub/assetsSurvival/incomePerMillion",//万份收益走势图
    "pms/product/pub/fundScaleShare",//规模份额
    "pms/product/pub/findFundHistoryYearlyroe",//七日年化列表
    "user/option/log",


    "pms/product/pub/getProductBase", // 基本盘列表
    "pms/product/pub/getProductTools", // 工具箱列表
    "pms/product/pub/getPubMarketingTagVo", // 工具箱列表--分类

    "pms/product/pub/getFixedInputPersonRecord", //获取定投历史
    "pms/product/pub/getFixedInputProductList", //获取定投产品列表
    "pms/product/pub/getNewFundManagerRecommendList", //新发基金-推荐位 
    "pms/product/pub/getNewFundProductList", //新发基金--产品列表
    "pms/product/pub/getCurrencyFundTitle", //货币基金--推荐位
    "pms/product/pub/getCurrencyFund", //货币基金--产品列表
    "pms/product/pub/getHomePageProductList", //公募首页进取投资/稳健投资产品列表
    "pms/product/pub/getAppScrollMessageResList", //公募首页滚动消息列表
    "pms/product/pub/filter/getFilterProductList",//基金筛选
    "pms/product/pub/filter/getFundCompanyList",//基金筛选-基金公司列表
    "pms/product/pub/filter/getFundManagerList",//基金筛选-基金经理列表
    "pms/product/pub/filter/getFundThemeList",//基金筛选-基金主题列表
    "pms/product/pub/filter/addPubFilterRecord",//新增基金筛选记录
    "pms/product/pub/filter/getPubFilterRecord",//查询基金筛选记录
    "pms/product/pub/filter/getFilterProductFundTypeList",//基金分类
    "pms/product/pub/filter/addCondition",//保存条件分类
    "pms/product/pub/filter/conditionList",//条件名称列表
    "pms/product/pub/filter/editCondition",//修改条件名称
    "pms/product/pub/filter/delCondition",//删除条件
    "pms/product/pub/filter/topCondition",//置顶条件
    "pms/product/pub/filter/conditionDetail",//查看条件详情
    "pms/product/pub/filter/addShareRecord",//生成分享记录
    "pms/product/pub/filter/shareProductList",//分享列表
    "pms/product/pub/getStockBondInterestMargin", //风向标下方 双折线图
    "pms/product/pub/getWindVaneTitle", //风向标上方 头部信息
    "pms/product/pub/getWindVane", //风向标 柱状图
    "pms/product/pub/getThermometer", //温度计下方 列表
    "pms/product/pub/getPubProductList", //公募榜单
    "pms/product/pub/getTodayPubFinancialBreakfast", //财经早餐-首页
    "pms/product/pub/getPubFinancialBreakfastDetail", //财经早餐-App详情+分享详情
    "pms/product/pub/getPubFinancialBreakfastPreview", //财经早餐-预览(中台预览)
    "pms/product/pub/addPubFilterRecord",//新增基金筛选记录
    "pms/product/pub/getPubFilterRecord",//查询基金筛选记录
    "pms/product/pub/getFilterProductFundTypeList",//基金分类

    //二期
    // "pms/product/pub/getPubRobustFinancialManage",//稳健理财
    // "pms/product/pub/getPubRobustFinancialManageRecommend", // 稳健理财推荐位
    // "pms/product/pub/addPubMessageDisplay",//增加关闭消息记录
    // "pms/product/pub/chasingRevenue",//追求收益

    "pms/product/pub/getPubRobustFinancialManage",//稳健理财
    "pms/product/pub/getPubRobustFinancialManageRecommend", // 稳健理财推荐位
    "pms/product/pub/addPubMessageDisplay",//增加关闭消息记录
    "pms/product/pub/chasingRevenue",//追求收益



    "pms/product/pub/getFundComparisionResult", // 基金PK
    "pms/product/pub/getFundComparisionResultYearYied", // 年度业绩
    "pms/product/pub/getFundComparisionResultManager", // 基金经理
    "pms/product/pub/delProductAddProductCompareRecord", // 删除基金

    "pms/product/pub/productCompareHotFundList" ,//热门基金
    "pms/product/pub/productCompareOwnOptionalList" ,//我的自选
    "pms/product/pub/productCompareRecentBrowseList" ,//最近浏览
    "pms/product/pub/productCompareRecordList" ,//对比记录
    "pms/product/pub/productCompareSearchFundList" ,//搜索基金
    "pms/product/pub/productCompareChoiceList",//基金选择
    "pms/product/pub/addProductCompareChoice", //基金选择新增
    "pms/product/pub/deleteProductCompareChoice", //基金选择删除
    "pms/product/pub/deleteProductCompareRecord",//清除历史对比记录
    "pms/product/pub/addProductCompareRecord",//新增对比记录
    "pms/product/pub/deleteProductCompareRecentBrowse", //清除浏览记录
    "pms/product/pub/getProductBaseDraft",//基本盘预览
    "pms/product/pub/getPubMarketingTagVoDraft",//工具箱列表--分类预览
    "pms/product/pub/getProductToolsDraft",//工具箱列表预览
    "pms/product/pub/getNewProductDraftList",//新发基金预览
    "pms/product/pub/getProductRecommend",//货币基金预览
    "pms/product/pub/productSearch",       //产品搜索

    "pms/product/pub/getFundComparisionResultGraphics", // 公募首页改版-基金对比走势图
    "pms/product/pub/getFundComparisionResult", // 公募首页改版-基金对比

    "pms/product/pub/addPubProductDetailRecord",//产品浏览记录
    "pms/product/pub/addOwnRecord",//自选埋点
    "pms/product/pub/loginInfoBuriedPoint",//新版公募相关页面埋点
    // 三期
    "pms/product/pub/theme/list", //主题选基列表
    "pms/product/pub/fund/index/list", //指数选基列表
    "pms/product/pub/fund/index/type", //指数类型

    "pms/product/pub/stock/choosing/fund", // 股票选基首页
    "pms/product/pub/stock/choosing/fund/result", // 股票选基结果

    "pms/product/pub/theme/search",//主题搜索
    "pms/product/pub/theme/detail",//主题详情
    "pms/product/pub/fund/index/detail",//指数详情
    "pms/product/pub/fund/index/search",//指数搜索
    "pms/product/pub/stock/choosing/search",//股票搜索 
    "pms/product/pub/theme/recommend", // 看主题
    "pms/product/pub/stock/choosing/look/stock", // 看股票
    "pms/product/pub/fund/index/look/index", // 看指数
    
    // 四期
    "pms/product/pub/getPublicOfferingInterpretation",//公募首页改版-公募解读
    "pms/product/pub/getFeaturedThisWeek",//公募首页滚动消息列表
    "pms/product/pub/getLupuObserveTypeList", // 公募首页改版-陆浦观察标签列表
    "pms/product/pub/getLupuObserve", // 公募首页改版-陆浦观察列表

    "pms/product/pub/pubShareSignature",//H5分享获取签名
    "pms/product/pub/addPubShareRecord",//H5分享接口
    "pms/product/pub/home/bannerList",//公募首页banner图列表
    "pms/product/pub/home/districtList",//公募首页金刚区
    "pms/product/pub/home/columnList",//公募首页栏目列表
    "pms/product/pub/home/indexList",//看指数预览列表
    "pms/product/pub/home/performanceList",//看业绩预览列表
    "pms/product/pub/home/stockList",//看股票预览列表
    "pms/product/pub/home/themeList",//看主题预览列表
    "pms/product/pub/home/steadyList",//看稳健投资预览列表
    "pms/product/pub/getHomePageRecommendList",//首页推荐位
    "tms/pub/bundle/booking/enabled",//我的自选是否展示批量买入按钮
    "pms/product/pub/productList", // 获取基金详情列表
    'pms/product/pub/productMarketingPageDetail', //获取基金详情列表
    //开户草稿新增接口
    "cms/cmsGroupAccount/saveGroupInformation",
    "cms/InvestorCreitApply/saveInvestorApplicationDraft",//保存草稿合格投资者认定
    'cms/cmsGroupAccount/saveMainBodyDraft', //非实名保存个人相关信息
    'cms/cmsGroupAccount/groupDraftInformationEcho',//获取非身份证实名信息草稿
    'cms/cmsGroupAccount/personMainBodyDraftEcho',//获取非身份证相关信息草稿
    "pms/product/private/templateDetailShareVerification",
    "personalCenter/judgeCancelStatus", //销户

    'cmsGroupAccount/addOcrInfo', //OCR信息

    'home/index/88888888/88888888'

]
export const INVESTOR_STATUS = [
    {
        'code':'10',
        'status':'认定失败'
    },
    {
        'code':'20',
        'status':'审批中'
    },
    {
        'code':'30',
        'status':'认定成功'
    },
    {
        'code':'40',
        'status':'已过期'
    },
]
export const NATIVE_BACK = [
   "/primaryMarketDetail",
   "/primaryOldDetail",
   "/personalProcess/realInfo",
   "/publicFundsDetail",
   "/realInfo",
   "/addBank",
   "/bankCardList",
   "/accountInfo",
   "/modifyEmail",
   "/contactAdd",
   "/personalProcess/notIdentityInfo",
   "/privateSurvival",
   "/publicSurvival",
   "/orgAccountInfo",
   "/orgBasicInfo",
   "/publicFundsDealRules",
   "/disclosureNative",
   "/orgAccountProcess",
   "/wealthAdvisor",
   "/orgDetail",
]
export const MY_PATH = [
    "/bankCardList",
    "/modifyEmail",
    "/contactAdd",
    "/wealthAdvisor",
    "/orgDetail",
    "/primaryMarketDetail",
    "/primaryOldDetail",
    "/assetCertificate"
 ]
 export const ADD_RECORD_Path = [
    "/editAddr",
    "/editEmail",
    "/editFixedPhone",
    "/taxRevenue",
    "/personalAdditionalRecording",
    "/searchOldExample"
 ]
